export const enClientPortalUserSettingsPagePages = {
    settings: {
        userSettingsPage: {
            locales: {
                'de-DE': 'German',
                'en-US': 'English',
            },
            actions: {
                continueToOrders: 'Continue to valuation orders',
            },
            modal: {
                title: 'Settings',
                tabs: {
                    general: 'General',
                    notifications: 'Notifications',
                },
                unsavedChanges: {
                    title: 'Unsaved changes',
                    message: 'What should happen to your changes before you continue?',
                    discardAndContinue: 'Discard & continue',
                    saveAndContinue: 'Save & continue',
                },
                profileImage: 'Profile picture',
                uploadImage: 'Upload',
                removeImage: 'Remove',
                removeImageConfirmation: {
                    title: 'Remove profile picture?',
                    message: 'Your profile picture will be permanently removed. Do you want to continue?',
                },
                rowLabels: {
                    email: 'Email',
                    phoneNumber: 'Phone',
                },
            },
            profile: {
                personalProfile: 'Personal profile',
                logout: 'Sign out',
                headerImageAlt: 'Generic header image',
                userImageAlt: 'User image',
                uploadImageAriaLabel: 'Upload profile image',
                teamSectionTitle: 'Team',
            },
        },
    },
}

export const enClientPortalUserSettingsPageValidation = {
    required: 'Required field',
    invalidPhoneNumber: 'Invalid phone number',
}
